import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/projekty/$projectId')({
  component: ProjectLayout,
})

/** Layout pass-through dla podstron projektu (/serp, /audyt, etc.) */
function ProjectLayout() {
  return <Outlet />
}
